const CheckSVG = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4 12.6111L8.92308 17.5L20 6.5"
        stroke="#000000"
        stroke-width="2"
        // stroke-linecap="round"
        // stroke-linejoin="round"
      />
    </svg>
  );
};

export default CheckSVG;
